
module.exports = function (errors) {    
    if(errors instanceof Array){
        if(errors.length > 0){
            for(var i = 0; i<errors.length; i++){
                if(errors[i].code == 401){
                    return true;                    
                }
            }
        }
    }
    return false;    
}